module.exports = __webpack_public_path__ + "img/success-logo.79902238.png";